import { IMultiStepDialogInstance } from "../dialog-instance/interfaces/IMultiStepDialogInstance";
import { dialogViewSubject } from "./DialogViewSubject.const";
import { DialogRenderer } from "./types/DialogRenderer";

export const reactDialogRenderer: DialogRenderer = (dialog: IMultiStepDialogInstance<any>) => {
    dialogViewSubject.next(dialog);
};
